module.exports = __webpack_public_path__ + "e4001b0daaf60075ce041408fb620434.svg";